import React from 'react';
import AsyncSelect from 'react-select/async';
import { handleLoadSelectOptions, mapValues } from '../../../util/Utilities';
import useServices from '../../../hooks/useServices';
import { Dropdown, Badge } from 'react-bootstrap';

const AcquisitionUserFilters = ({ filters, setFilters }) => {
    const [{ services, loading: servicesLoading }, getServices] = useServices({ params: { perPage: 50 } }, { useCache: false });

    // Función para manejar cambios en los filtros
    const handleChange = (e) => {
        setFilters((oldFilters) => ({
            ...oldFilters,
            page: 1,
            [e.target.name]: e.target.value
        }));
    };

    // Función para contar los filtros activos, excluyendo 'page' y 'perPage'
    const countActiveFilters = () => {
        return Object.entries(filters).filter(([key, value]) => {
            // Excluir 'page' y 'perPage' del conteo
            return key !== 'page' && key !== 'perPage' && value !== '' && value !== undefined && value !== null;
        }).length;
    };

    return (
        <div className="row align-items-center">
            <div className="col-md-12">
                <Dropdown>
                    {/* Botón del dropdown con el contador de filtros activos */}
                    <Dropdown.Toggle variant="primary" id="dropdown-filters">
                        Filtros {' '}
                        <Badge bg="light" text="dark" pill>
                            {countActiveFilters()}
                        </Badge>
                    </Dropdown.Toggle>

                    {/* Menú desplegable con scroll */}
                    <Dropdown.Menu className="p-3" style={{ minWidth: '300px', maxHeight: '400px', overflowY: 'auto' }}>
                        <div className="mb-3">
                            <label className="text-primary">ID</label>
                            <input
                                type="text"
                                className="form-control"
                                name="id"
                                value={filters?.id}
                                onChange={handleChange}
                                placeholder="ID"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="text-primary">Nombre del usuario</label>
                            <input
                                type="text"
                                className="form-control"
                                name="user_name"
                                value={filters?.user_name}
                                onChange={handleChange}
                                placeholder="Nombre del usuario"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="text-primary">Servicios</label>
                            <AsyncSelect
                                isClearable
                                onFocus={getServices}
                                isLoading={servicesLoading}
                                defaultOptions={mapValues(services)}
                                name="service_id"
                                loadOptions={(e) => handleLoadSelectOptions(e, getServices)}
                                placeholder="Escriba el nombre para buscar..."
                                onChange={(e) => handleChange({ target: { value: e?.value, name: 'service_id' } })}
                                menuPortalTarget={document.body} // Para que el menú del select no se corte
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // Asegura que el menú del select esté por encima de otros elementos
                                }}
                            />
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
};

export default AcquisitionUserFilters;